export const projects = [
  {
    title: "SWE Meeting Tracker",
    subtitle: "MERN: MongoDB, Express, React, Node",
    description:
      "Society of Women Engineers requested a more efficent way to track attendance to club meetings so we created a website with an admin and user page to better track attendance of 100+ members.",
    image: "./sweMeeting.gif",
    link: "https://ruswe.onrender.com/",
  },
  {
    
    title: "PEEK Student",
    subtitle: "Python, Flask, MongoDB, Auth0, GeminiAPI HTML/CSS/JS",
    description:
      "Get reccomended professors based on your preferences and see what other students have to say about them. It uses a MongoDB database to store user data and reviews.",
    image: "./peekstudent.gif",
    link: "https://devpost.com/software/peek-student",
  },
  {
    title: "RUAttending?",
    subtitle: "MERN: MongoDB, Express, React, Node, TailwindCSS",
    description:
      "In response to RU Missed Connections, we developed a wesbite to be able to connect with other peers and attend local events while adding them to the Google Calendar API.",
    image: "./RUAttending_Demo.gif",
    link: "https://devpost.com/software/ru-attending",
  },
  {
    title: "ResumeReviser",
    subtitle: "Python, Flask, SQLite3, Bootstrap",
    description:
      "Search for a job listing and upload a pdf of your resume and the website returns a percentage match to the job. It uses NLP, specifically, cosine similarity for the calculation.",
    image: "./ResumeReviser.gif",
    link: "https://devpost.com/software/resumereview",
  },
  {
    title: "HabitHatch!",
    subtitle: "MERN: MongoDB, Express, React, Node",
    description:
      "Complete tasks with an anonymous partner and hatch eggs after completing all 5 tasks. Uses database, MongoDB, to store user data and stats. It includes OpenAI API and a Twillio API.",
    image: "./habithatch!.gif",
    link: "https://devpost.com/software/habithatch-wr3z7n",
  },
 

  // {
  //   title: "MyLecturePal",
  //   subtitle: "MERN: MongoDB, Express, React, Node, HTML/CSS/JS",
  //   description:
  //     "Help keep track of student ratings on each lecture topic. Students who rate higher have the ability to sign up to offer help to students who rated lower.  HACKATHON 1ST PLACE WINNER",
  //   image: "./mylecturepal.gif",
  //   link: "https://devpost.com/software/mylecturepal",
  // },
  {
    title: "TrashBash",
    subtitle: "C#, Unity",
    description:
      "A RPG about educating the youth about waste management by battling climate change monsters in a dungeon and avoiding obstacles. HACKATHON WINNER",
    image: "./trashbash.gif",
    link: "https://devpost.com/software/trashbash-recycling-rpg",
  }
];


export const skills = [
  "Java",
  "Python",
  "Flask",
  "React",
  "C",
  "JavaScript",
  "SQL",
  "MongoDB",
  "HTML/CSS/JS",
  "Git"
];

const timelinedata =[
  {
    text: 'HACKRU Fall 2020 - Scarlet Knight Word Dash',
    date: 'November 08 2020',
    category: {
        tag: 'Participant',
        color: '#f08080'
    },
    link: {
        url:
            'https://devpost.com/software/knights-word-hunt',
        text: 'Check it Out'
    }
  },
  {
    text: 'HackHERS 2023 - RutgersRun!',
    date: 'Febrauary 12 2023',
    category: {
        tag: 'Participant',
        color: '#f08080'
    },
    link: {
        url:
            'https://devpost.com/software/the-rulife',
        text: 'Check it Out'
    }
  },
  {
    text: 'HackRU Spring 2023 - TrashBash',
    date: 'Febrauary 26 2023',
    category: {
        tag: 'Winner',
        color: '#90e0ef'
    },
    link: {
        url:
            'https://devpost.com/software/trashbash-recycling-rpg',
        text: 'Check it Out'
    }
  },
  {
    text: 'WiCHacks 2023 - Virus Attack',
    date: 'March 05 2023',
    category: {
        tag: 'Participant',
        color: '#f08080'
    },
    link: {
        url:
            'https://devpost.com/software/virus-attack',
        text: 'Check it Out'
    }
  },
  {
    text: 'Social Good RIEEE - SWE Meeting Tracker',
    date: 'March 26 2023',
    category: {
        tag: 'Winner',
        color: '#90e0ef'
    },
    link: {
        url:
            'https://devpost.com/software/the-best-swe-meeting-tracker',
        text: 'Check it Out'
    }
  },
  {
    text: 'HackPrinceton Spring 2023 - Sheet Music Scanner',
    date: 'April 02 2023',
    category: {
        tag: 'Participant',
        color: '#f08080'
    },
    link: {
        url:
            'https://devpost.com/software/sheet-music-scanner',
        text: 'Check it Out'
    }
  },
  {
    text: 'HackTCNJ 2023 - HabitHatch!',
    date: 'April 16 2023',
    category: {
        tag: 'Participant',
        color: '#f08080'
    },
    link: {
        url:
            'https://devpost.com/software/habithatch-wr3z7n',
        text: 'Check it out'
    }
  },       
  {
    text: 'HawkHacks 2023 - MyLecturePal',
    date: 'April 30 2023',
    category: {
        tag: 'Winner',
        color: '#90e0ef'
    },
    link: {
        url:
            'https://devpost.com/software/mylecturepal',
        text: 'Check it out'
    }
  },
  {
    text: 'PennAppsXXIV - Sustainably Yours Forum',
    date: 'September 8 2023',
    category: {
      tag: 'Participant',
      color:'#f08080' 
    },
    link: {
      url: 
          'https://devpost.com/software/project-8pardj9solib?ref_content=user-portfolio&ref_feature=in_progress',
      text : 'Check it out'
    }
  },
  {
    text: 'Divhacks 2023 - Veggie Guard',
    date: 'September 23 2023',
    category: {
      tag: 'Participant',
      color:'#f08080' 
    },
    link: {
      url: 
          'https://devpost.com/software/veggie-guard',
      text : 'Check it out'
    }
  },
  {
    text: 'HACKRU Fall 2023 - RUAttending?',
    date: 'October 7 2023',
    category: {
      tag: 'Participant',
      color:'#f08080' 
    },
    link: {
      url: 
          'https://devpost.com/software/ru-attending',
      text : 'Check it out'
    }
  },
    {
    text: 'Technica 2023 - Your Green Planet',
    date: 'October 21 2023',
    category: {
      tag: 'Winner',
      color:'#90e0ef' 
    },
    link: {
      url: 
          'https://devpost.com/software/your-green-planet',
      text : 'Check it out'
    }
  },
  {
    text: 'HackPrinceton Fall 2023 - Resume Reviser',
    date: 'October 21 2023',
    category: {
      tag: 'Winner',
      color:'#90e0ef' 
    },
    link: {
      url: 
          'https://devpost.com/software/resumereview',
      text : 'Check it out'
    }
  },
  {
    text: 'HackHERS 2024 - BalancSync',
    date: 'February 10 2024',
    category: {
      tag: 'Winner',
      color:'#90e0ef' 
    },
    link: {
      url: 
          'https://devpost.com/software/balancsync',
      text : 'Check it out'
    }
  },
  {
    text: 'Social Good RIEEE - DRC Women in Stem Empowerment',
    date: 'February 24 2024',
    category: {
      tag: 'Winner',
      color:'#90e0ef' 
    },
    link: {
      url: 
          'https://devpost.com/software/drc-hack',
      text : 'Check it out'
    }
  },
  {
    text: 'HackRU Spring 2024 - Green Habits',
    date: 'March 23 2024',
    category: {
      tag: 'Winner',
      color:'#90e0ef' 
    },
    link: {
      url: 
          'https://devpost.com/software/green-habits',
      text : 'Check it out'
    }
  },
  {
    text: 'HackPrinceton Spring 2024 - New Leaf',
    date: 'March 30 2024',
    category: {
      tag: 'Winner',
      color:'#90e0ef' 
    },
    link: {
      url: 
          'https://devpost.com/software/newleaf',
      text : 'Check it out'
    }
  },
  {
    text: 'DragonHacks 2024 - PEEK Student',
    date: 'April 14 2024',
    category: {
      tag: 'Winner',
      color:'#90e0ef' 
    },
    link: {
      url: 
          'https://devpost.com/software/peek-student',
      text : 'Check it out'
    }
  }
]

timelinedata.reverse();
export default timelinedata;


// WEBPACK FOOTER //
// ./src/data.js